(function () {
  "use strict";

  var SHIP_DEFAULT = 40000;

  function formatMoney(cents) {
    var format =
      (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) ||
      "{{amount}}";
    var amount = (cents / 100).toFixed(2);
    var amountComma = amount.replace(".", ",");
    var amountNoDecimals = String(Math.round(cents / 100));

    return format
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function tick(el) {
    if (!el) return;
    el.classList.remove("is-tick");
    requestAnimationFrame(function () {
      el.classList.add("is-tick");
    });
  }

  function flashItem(item) {
    if (!item) return;
    item.classList.remove("is-flash");
    requestAnimationFrame(function () {
      item.classList.add("is-flash");
    });
  }

  function initPackRoot(root) {
    if (!root || root.dataset.bound === "1") return;
    root.dataset.bound = "1";

    var boardPriceEl = root.querySelector("[data-zeus-pack-board-price]");
    var boardNameEl = root.querySelector("[data-zeus-pack-board-name]");
    var boardThumbEl = root.querySelector(".zeus-pack-modal__board-thumb");
    var totalEl = root.querySelector("[data-zeus-pack-total]");
    var savingsEl = root.querySelector("[data-zeus-pack-savings]");
    var shipMsgEl = root.querySelector("[data-zeus-pack-ship-msg]");
    var shipBarEl = root.querySelector("[data-zeus-pack-ship-bar]");
    var addBtn = root.querySelector("[data-zeus-pack-add]");
    var soloBtn = root.querySelector("[data-zeus-pack-solo]");
    var errorEl = root.querySelector("[data-zeus-pack-error]");
    var formId = root.getAttribute("data-product-form-id");
    var productForm = formId ? document.getElementById(formId) : null;
    var shipThreshold = parseInt(root.getAttribute("data-ship-threshold"), 10) || SHIP_DEFAULT;
    var shipRemainingTpl = root.getAttribute("data-ship-remaining") || "";
    var shipFreeMsg = root.getAttribute("data-ship-free") || "";
    var boardTitleBase = boardNameEl && boardNameEl.textContent ? boardNameEl.textContent.split(" · ")[0].trim() : "";

    function boardMediaSrc(variant, width) {
      var media = variant && (variant.featured_media || variant.featured_image);
      if (!media) return "";
      var preview = media.preview_image || media;
      var src = preview.src || media.src || "";
      if (!src) return "";
      if (src.indexOf("//") === 0) src = "https:" + src;
      try {
        var url = new URL(src);
        url.searchParams.set("width", String(width || 200));
        return url.toString();
      } catch (err) {
        return src;
      }
    }

    function getBoardPrice() {
      return parseInt(root.getAttribute("data-board-price"), 10) || 0;
    }

    function getBoardVariantId() {
      return parseInt(root.getAttribute("data-board-variant-id"), 10);
    }

    function getSelectedItems() {
      return Array.prototype.slice
        .call(root.querySelectorAll("[data-zeus-pack-item].is-selected"))
        .filter(function (item) {
          return (
            item.getAttribute("data-available") !== "false" && !!parseInt(item.getAttribute("data-variant-id"), 10)
          );
        });
    }

    function canAddPack() {
      if (!getBoardVariantId() || root.getAttribute("data-board-available") === "false") return false;
      var required = Array.prototype.slice.call(root.querySelectorAll('[data-zeus-pack-item][data-locked="1"]'));
      if (root.getAttribute("data-requires-leash") === "true" && !required.length) return false;
      return required.every(function (item) {
        return (
          item.classList.contains("is-selected") &&
          item.getAttribute("data-available") !== "false" &&
          !!parseInt(item.getAttribute("data-variant-id"), 10)
        );
      });
    }

    function updateAddButton() {
      if (addBtn) addBtn.disabled = addBtn.hasAttribute("data-loading") || !canAddPack();
    }

    function setItemAvailability(item, available) {
      item.setAttribute("data-available", String(available));
      item.classList.toggle("zeus-pack-item--unavailable", !available);
      var soldout = item.querySelector(".zeus-pack-item__soldout");
      if (soldout) soldout.hidden = available;
      var prices = item.querySelector(".zeus-pack-item__prices");
      if (prices) prices.hidden = !available;
      var meta = item.querySelector(".zeus-pack-item__meta");
      if (meta) meta.hidden = !available;
      var toggle = item.querySelector("[data-zeus-pack-toggle]");
      if (toggle) toggle.disabled = !available || item.getAttribute("data-locked") === "1";
      if (!available) {
        item.classList.remove("is-selected");
        item.setAttribute("data-variant-id", "");
        item.setAttribute("data-price", "0");
        item.setAttribute("data-compare", "0");
        if (toggle) toggle.setAttribute("aria-pressed", "false");
        item.querySelectorAll("[data-color-swatch]").forEach(function (swatch) {
          swatch.classList.remove("is-active");
          swatch.setAttribute("aria-pressed", "false");
        });
      }
    }

    function updateShipping(total) {
      if (!shipMsgEl || !shipBarEl) return;
      if (total >= shipThreshold) {
        if (shipFreeMsg) shipMsgEl.textContent = shipFreeMsg;
        shipBarEl.style.width = "100%";
      } else {
        var amount = formatMoney(shipThreshold - total);
        if (shipRemainingTpl) {
          shipMsgEl.textContent = shipRemainingTpl.replace(/AMOUNT/g, amount);
        }
        shipBarEl.style.width = Math.min(100, (total / shipThreshold) * 100) + "%";
      }
    }

    function updateTotals() {
      var total = getBoardPrice();
      var savings = 0;

      getSelectedItems().forEach(function (item) {
        var price = parseInt(item.getAttribute("data-price"), 10) || 0;
        var compare = parseInt(item.getAttribute("data-compare"), 10) || 0;
        total += price;
        savings += Math.max(0, compare - price);
      });

      if (totalEl) {
        totalEl.textContent = formatMoney(total);
        tick(totalEl);
      }
      if (savingsEl) {
        savingsEl.textContent = formatMoney(savings);
        tick(savingsEl);
      }
      updateShipping(total);
      updateAddButton();
    }

    function setBoardFromVariant(variant) {
      if (!variant) return;
      root.setAttribute("data-board-variant-id", String(variant.id));
      root.setAttribute("data-board-price", String(variant.price));
      root.setAttribute("data-board-available", String(variant.available));
      if (boardPriceEl) boardPriceEl.textContent = formatMoney(variant.price);
      if (boardNameEl) {
        var base = boardTitleBase || boardNameEl.textContent.split(" · ")[0].trim();
        if (variant.title && variant.title !== "Default Title") {
          boardNameEl.textContent = base + " · " + variant.title;
        } else {
          boardNameEl.textContent = base;
        }
      }
      var thumbSrc = boardMediaSrc(variant, 200);
      if (thumbSrc && boardThumbEl && boardThumbEl.tagName === "IMG") {
        boardThumbEl.src = thumbSrc;
        boardThumbEl.removeAttribute("srcset");
      }
      updateTotals();
    }

    function setItemSelected(item, selected) {
      if (!item || item.getAttribute("data-locked") === "1" || item.getAttribute("data-available") === "false") return;
      item.classList.toggle("is-selected", selected);
      var btn = item.querySelector("[data-zeus-pack-toggle]");
      if (btn) btn.setAttribute("aria-pressed", selected ? "true" : "false");
      flashItem(item);
      updateTotals();
    }

    root.querySelectorAll("[data-zeus-pack-toggle]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var item = btn.closest("[data-zeus-pack-item]");
        if (!item || item.getAttribute("data-locked") === "1" || btn.disabled) return;
        setItemSelected(item, !item.classList.contains("is-selected"));
      });
    });

    var discountPct = parseInt(root.getAttribute("data-discount-pct"), 10) || 0;
    var discountMultiplier = (100 - discountPct) / 100;

    function applyPackVariant(item, variantId, basePriceCents, compareCents) {
      if (!item || !variantId) return;
      var packPrice = Math.round(basePriceCents * discountMultiplier);
      var compare = compareCents && compareCents > packPrice ? compareCents : basePriceCents;
      item.setAttribute("data-variant-id", String(variantId));
      item.setAttribute("data-price", String(packPrice));
      item.setAttribute("data-compare", String(compare));

      var compareEl = item.querySelector("[data-zeus-pack-item-compare]");
      var priceEl = item.querySelector("[data-zeus-pack-item-price]");
      if (compareEl) compareEl.textContent = formatMoney(compare);
      if (priceEl) priceEl.textContent = formatMoney(packPrice);
      updateTotals();
    }

    function selectSwatch(item, swatch) {
      if (!item || !swatch || swatch.disabled) return;
      var variantId = parseInt(swatch.getAttribute("data-variant-id"), 10);
      var basePrice = parseInt(swatch.getAttribute("data-price"), 10);
      var compareAt = parseInt(swatch.getAttribute("data-compare-at"), 10);
      if (!variantId || isNaN(basePrice)) return;

      item.querySelectorAll("[data-color-swatch]").forEach(function (s) {
        s.classList.toggle("is-active", s === swatch);
        s.setAttribute("aria-pressed", s === swatch ? "true" : "false");
      });

      var metaEl = item.querySelector(".zeus-pack-item__meta:not(.zeus-pack-item__meta--warn)");
      if (metaEl && swatch.getAttribute("aria-label") && item.getAttribute("data-kind") === "textile") {
        metaEl.textContent = swatch.getAttribute("aria-label");
      }

      var variantImg = swatch.getAttribute("data-variant-img");
      var thumbEl = item.querySelector("img.zeus-pack-item__thumb");
      if (variantImg && thumbEl) {
        thumbEl.src = variantImg;
        thumbEl.removeAttribute("srcset");
      }

      applyPackVariant(item, variantId, basePrice, isNaN(compareAt) ? 0 : compareAt);

      setItemAvailability(item, true);
      item.classList.add("is-selected");
      var toggleBtn = item.querySelector("[data-zeus-pack-toggle]");
      if (toggleBtn) toggleBtn.setAttribute("aria-pressed", "true");
      updateTotals();
    }

    root.querySelectorAll("[data-zeus-pack-swatches]").forEach(function (rail) {
      rail.addEventListener("click", function (e) {
        var item = rail.closest("[data-zeus-pack-item]");
        if (!item) return;

        var sizeBtn = e.target.closest("[data-zeus-pack-leash-size]");
        if (sizeBtn) {
          var size = sizeBtn.getAttribute("data-zeus-pack-leash-size");
          if (!size) return;

          rail.querySelectorAll("[data-zeus-pack-leash-size]").forEach(function (btn) {
            var on = btn === sizeBtn;
            btn.classList.toggle("is-active", on);
            btn.setAttribute("aria-pressed", on ? "true" : "false");
          });

          var fitPill = item.querySelector("[data-zeus-pack-fit-pill]");
          if (fitPill) fitPill.textContent = size;

          rail.querySelectorAll("[data-leash-group]").forEach(function (wrap) {
            var group = wrap.getAttribute("data-leash-group");
            var match = group === size;
            if (wrap.classList.contains("zeus-pack-builder__swatch-wrap") || wrap.hasAttribute("data-leash-group")) {
              if (wrap.tagName === "BUTTON") return;
              wrap.hidden = !match;
            }
          });
          rail.querySelectorAll("button[data-color-swatch][data-leash-group]").forEach(function (btn) {
            var wrap = btn.closest(".zeus-pack-builder__swatch-wrap");
            if (wrap) wrap.hidden = btn.getAttribute("data-leash-group") !== size;
          });

          var first =
            rail.querySelector(".zeus-pack-builder__swatch-wrap:not([hidden]) [data-color-swatch]:not([disabled])") ||
            rail.querySelector(
              '[data-color-swatch][data-leash-group="' + size.replace(/"/g, "") + '"]:not([disabled])',
            );
          if (first) {
            selectSwatch(item, first);
          } else {
            setItemAvailability(item, false);
            updateTotals();
          }
          return;
        }

        var swatch = e.target.closest("[data-color-swatch]:not([disabled])");
        if (swatch) selectSwatch(item, swatch);
      });
    });

    root.querySelectorAll("[data-zeus-pack-tip]").forEach(function (wrap) {
      var btn = wrap.querySelector("[data-zeus-pack-tip-toggle]");
      var pop = wrap.querySelector(".zeus-pack-modal__tip-pop");
      if (!btn) return;
      btn.addEventListener("click", function (e) {
        e.stopPropagation();
        var open = !wrap.classList.contains("is-open");
        root.querySelectorAll("[data-zeus-pack-tip].is-open").forEach(function (other) {
          other.classList.remove("is-open");
          var ob = other.querySelector("[data-zeus-pack-tip-toggle]");
          var op = other.querySelector(".zeus-pack-modal__tip-pop");
          if (ob) ob.setAttribute("aria-expanded", "false");
          if (op) op.hidden = true;
        });
        wrap.classList.toggle("is-open", open);
        btn.setAttribute("aria-expanded", open ? "true" : "false");
        if (pop) pop.hidden = !open;
      });
    });

    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-zeus-pack-tip]")) return;
      root.querySelectorAll("[data-zeus-pack-tip].is-open").forEach(function (wrap) {
        wrap.classList.remove("is-open");
        var btn = wrap.querySelector("[data-zeus-pack-tip-toggle]");
        var pop = wrap.querySelector(".zeus-pack-modal__tip-pop");
        if (btn) btn.setAttribute("aria-expanded", "false");
        if (pop) pop.hidden = true;
      });
    });

    if (productForm) {
      productForm.addEventListener(
        "variant:change",
        function (e) {
          if (!e.detail || !e.detail.variant) return;
          setBoardFromVariant(e.detail.variant);
        },
        { passive: true },
      );
    }

    if (soloBtn) {
      soloBtn.addEventListener("click", function () {
        var overlay = root.closest("[data-zeus-modal-overlay]");
        if (overlay && window.ZeusModal) window.ZeusModal.close(overlay.id);
      });
    }

    function refreshAvailability(selectedItems) {
      var products = selectedItems.map(function (item) {
        return { url: item.getAttribute("data-product-url"), item: item };
      });
      products.push({ url: root.getAttribute("data-board-product-url"), item: null });
      return Promise.all(
        products.map(function (entry) {
          if (!entry.url) return Promise.resolve();
          return fetch(entry.url + ".js", { headers: { Accept: "application/json" }, cache: "no-store" })
            .then(function (response) {
              if (!response.ok) throw new Error("Product availability refresh failed");
              return response.json();
            })
            .then(function (product) {
              if (!Array.isArray(product.variants)) return;
              var selectedId = entry.item
                ? parseInt(entry.item.getAttribute("data-variant-id"), 10)
                : getBoardVariantId();
              var selected = product.variants.find(function (variant) {
                return variant.id === selectedId;
              });
              if (!entry.item) {
                root.setAttribute("data-board-available", String(!!selected && selected.available));
                return;
              }
              entry.item.querySelectorAll("[data-color-swatch]").forEach(function (swatch) {
                var variant = product.variants.find(function (v) {
                  return v.id === parseInt(swatch.getAttribute("data-variant-id"), 10);
                });
                swatch.disabled = !variant || !variant.available;
                swatch.classList.toggle("is-disabled", swatch.disabled);
              });
              if (!selected || !selected.available) setItemAvailability(entry.item, false);
            })
            .catch(function () {
              // A failed read is not evidence that a variant is sold out.
            });
        }),
      ).then(updateTotals);
    }

    if (addBtn) {
      addBtn.addEventListener("click", function () {
        var boardVariantId = getBoardVariantId();
        if (!canAddPack() || addBtn.hasAttribute("data-loading")) return;
        if (errorEl) errorEl.hidden = true;

        var selectedItems = getSelectedItems();
        var items = [{ id: boardVariantId, quantity: 1 }];
        selectedItems.forEach(function (item) {
          var variantId = parseInt(item.getAttribute("data-variant-id"), 10);
          if (variantId) items.push({ id: variantId, quantity: 1 });
        });

        addBtn.disabled = true;
        addBtn.setAttribute("data-loading", "1");

        var cartAddUrl = window.Shopify?.routes?.root
          ? window.Shopify.routes.root + "cart/add.js"
          : window.routes?.cart_add_url
            ? window.routes.cart_add_url + ".js"
            : "/cart/add.js";

        fetch(cartAddUrl, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({ items: items }),
        })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(function (err) {
                err.status = res.status;
                throw err;
              });
            }
            return res.json();
          })
          .then(function () {
            var overlay = root.closest("[data-zeus-modal-overlay]");
            if (overlay && window.ZeusModal) window.ZeusModal.close(overlay.id);

            var cartJsUrl = window.Shopify?.routes?.root ? window.Shopify.routes.root + "cart.js" : "/cart.js";
            return fetch(cartJsUrl, { headers: { Accept: "application/json" } })
              .then(function (r) {
                return r.json();
              })
              .then(function (cart) {
                document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { cart: cart } }));
                document.dispatchEvent(new CustomEvent("cart:items-changed", { detail: { cart: cart } }));
                document.dispatchEvent(new CustomEvent("cart:add", { detail: { cart: cart } }));

                var drawer = document.getElementById("cart-drawer") || document.querySelector("cart-drawer");
                if (drawer && typeof drawer.open === "function") {
                  drawer.open();
                  return;
                }
                if (drawer && typeof drawer.show === "function") {
                  drawer.show();
                  return;
                }
                var ariaTrigger = document.querySelector('[aria-controls="cart-drawer"]');
                if (ariaTrigger) {
                  ariaTrigger.click();
                  return;
                }
                window.location.href = (window.routes && window.routes.cart_url) || "/cart";
              });
          })
          .catch(function (err) {
            console.error("[zeus-pack] cart add failed", err);
            var msg = (err && err.description) || root.getAttribute("data-add-error") || "";
            if (errorEl) {
              errorEl.textContent = msg;
              errorEl.hidden = false;
            }
            if (err && err.status === 422) return refreshAvailability(selectedItems);
          })
          .finally(function () {
            addBtn.removeAttribute("data-loading");
            updateAddButton();
          });
      });
    }

    root.querySelectorAll("[data-zeus-pack-item]").forEach(function (item) {
      if (item.getAttribute("data-available") === "false" || item.classList.contains("zeus-pack-item--unavailable")) {
        setItemAvailability(item, false);
      }
      item.querySelectorAll("[data-color-swatch]").forEach(function (swatch) {
        var active =
          !swatch.disabled && swatch.getAttribute("data-variant-id") === item.getAttribute("data-variant-id");
        swatch.classList.toggle("is-active", active);
        swatch.setAttribute("aria-pressed", active ? "true" : "false");
      });
    });
    updateTotals();
  }

  function initAll() {
    document.querySelectorAll("[data-zeus-pack-root]").forEach(initPackRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
